import React from 'react';
import AvatarImage from '../../../elements/AvatarImage';
import moment from 'moment';
import useFlashOnView from '../../../util/useFlashOnView';

const ChatMessage = ({ direction, time, name, avatarUrl, text, highlight = false }) => {
  const { ref, flashClassName } = useFlashOnView(highlight);

  return (
    <div ref={ref} className={`chat-message ${direction} ${flashClassName}`}>
      <span className="info">
        {moment(time).format('DD-MM-YYYY HH:MM')} - {name}
      </span>
      <div>
        <AvatarImage className="avatar" src={avatarUrl} alt="" height="64" width="64" />
        <p> {text} </p>
      </div>
    </div>
  );
};

export default ChatMessage;
